export default "__VITE_PUBLIC_ASSET__cd942b06__"